import styled from "styled-components";
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";

export const Container = styled.div(({ theme }) => ({
    background: theme.colors[theme.colorMode].background_Primary,
}));

export const OfferContainer = styled.div(({ theme }) => ({
    display: "flex",
    marginTop: theme.spacing.xSmall,

    ":first-child": {
        marginTop: 0,
    },
}));

export const OfferCode = styled(Text)(({ theme }) => ({
    marginLeft: theme.spacing.xSmall,
}));

export const OfferIconImg = styled.img({
    alignSelf: "normal",
});

export const OfferIconContainer = styled.div(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    alignSelf: "flex-start",
    borderRadius: theme.cornerRadius.xSmall,
    background: theme.colors[theme.colorMode].background_Primary,
}));
